// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail_auditNewDetail__HDAoN {
  padding-top: 12.8vw;
}
.detail_auditNewDetail__HDAoN .detail_iframe__1CbQ5 {
  border: none;
  width: 100%;
  height: calc(100vh - 12.8vw);
}`, "",{"version":3,"sources":["webpack://./src/pages/audit-new/components/detail/detail.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,YAAA;EACA,WAAA;EACA,4BAAA;AACJ","sourcesContent":[".auditNewDetail {\n  padding-top: 48px;\n\n  .iframe {\n    border: none;\n    width: 100%;\n    height: calc(100vh - 48px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auditNewDetail": `detail_auditNewDetail__HDAoN`,
	"iframe": `detail_iframe__1CbQ5`
};
export default ___CSS_LOADER_EXPORT___;
